import { render } from "./AddStory.vue?vue&type=template&id=000891ab&scoped=true&ts=true"
import script from "./AddStory.vue?vue&type=script&lang=ts"
export * from "./AddStory.vue?vue&type=script&lang=ts"

import "./AddStory.vue?vue&type=style&index=0&id=000891ab&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000891ab"]])

export default __exports__